<div class="avatar" [ngClass]="{ 'mode-text': !avatarPicture, 'mode-picture': avatarPicture }" *ngIf="userInfo">
    <div class="avatar-wrapper">
        <div *ngIf="avatarPicture" [style.background-image]="'url(' + avatarPicture! + ')'" class="profile-image"></div>
        <span class="avatar-caption" *ngIf="!avatarPicture">{{ isMine ? (userInfo | initials) : avatarModel.shortName }}</span>
    </div>
</div>
